export const evaluationType = {
  wound: "Wound",
  risk: "Risk"
};
